// extracted by mini-css-extract-plugin
module.exports = {"EventItem":"EventItem_EventItem__3rcTS"};